
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry/logistics-transportation/whatsapp",
      function () {
        return require("private-next-pages/industry/logistics-transportation/whatsapp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry/logistics-transportation/whatsapp"])
      });
    }
  